<template>
  <div class="c-grade">
    <span class="c-grade__header">年级分布</span>
    <div class="c-grade__bgc">
      <EmptyLearning v-if="!show"/>
      <div class="accurate-grade"></div>
    </div>
  </div>
</template>

<script>
import EmptyLearning from './empty-learning.vue';

export default {
  name: 'AccurateGrade',
  components: { EmptyLearning },
  props: {
    graspList: {
      require: true,
      default: () => [],
    },
  },
  data() {
    return {
      show: true,
    };
  },
  mounted() {
    // this.initCharts();
  },
  watch: {
    graspList(n) {
      if (Number(n.length) === 0) {
        this.show = false;
        this.initCharts();
      } else {
        this.show = true;
        this.initCharts();
      }
    },
  },
  methods: {
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.querySelector('.accurate-grade'));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          data: this.graspList.map((item) => item.grade),
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: '12',
            },
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: ['rgba(255, 255, 255, 0.3)'],
            },
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: '12',
            },
          },
        },
        series: [{
          data: this.graspList.map((item) => item.num),
          type: 'bar',
          barMaxWidth: 24,
          itemStyle: {
            normal: {
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#00F1FF',
              }, {
                offset: 0.72,
                color: '#48A6FF',
              }, {
                offset: 1,
                color: '#8A4FFF',
              }]),
              label: {
                formatter(params) {
                  return params.data;
                },
                show: true,
                position: 'top',
                textStyle: {
                  fontWeight: 500,
                  fontSize: '12',
                  color: '#fff',
                },
              },
            },
          },
        }],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-grade{
  box-sizing: border-box;

  &__header {
     display: block;
        position: relative;
        font-size: 28px;
        font-weight: 500;
        text-indent: 1em;
        color: #E3E2FF;
        &::before {
          content: '';
          position: absolute;
          width: 27px;
          height: 27px;
          top: 9px;
          left: -8px;
          background: url('../../images/cockpit-icon.png') no-repeat center / contain;
    }
  }
  &__bgc{
    margin-top:30px ;
    position: relative;
     width: 648px;
    height: 279px;
    background: linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    border-radius: 8px ;
    // opacity: 0.38;
    }
    .accurate-grade{
      position: absolute;
      top: 0;
      left: 0;
      width: 648px;
      height: 279px;
    }
  }

</style>
